import { createRouter } from '@tanstack/react-router'
import { installStaleChunkReload } from 'lib/stale-chunk-reload'
import { routeTree } from './routeTree.gen'

// At module scope, not in an effect: the first route's chunk is imported during
// hydration, before any effect has run, so a listener registered later would
// miss the one failure most likely to white-screen the page. No-ops on the
// server.
installStaleChunkReload()

// TanStack Start's required entry point: it calls this on the server for each
// request and once in the browser to hydrate. Returning a fresh router per call
// is what keeps one request's match state out of another's.
export function getRouter() {
   return createRouter({
      routeTree,
      defaultPreload: 'intent',
      // Loader data defaults to stale immediately, so navigating back to an
      // entry re-runs its loader and costs another dictionary request. Entries
      // change on the order of days, so five minutes of freshness is generous
      // to the data and removes the refetch on back/forward and re-visits.
      defaultStaleTime: 5 * 60 * 1000,
      scrollRestoration: true,
   })
}

declare module '@tanstack/react-router' {
   interface Register {
      router: ReturnType<typeof getRouter>
   }
}
